import { MarketStatus } from '@ps/web-sports-api-types';
import produce from 'immer';

import type { MarketPollingData } from '@swf/sports/types/market';
import updateMarket from '@swf/sports/utils/updateMarket';

import type { CompetitionOutrightsData } from '../types';

import { defaultState } from './defaultState';

type State = typeof defaultState;

const updateMarkets = (state: State, payload: MarketPollingData) =>
  produce(state, (draft) => {
    draft.outrights?.forEach((outright) => {
      outright.markets.forEach((market) => {
        if (payload.closed.includes(market.id)) {
          market.marketStatus = MarketStatus.CLOSED;
          return;
        }
        const marketUpdate = payload.data[market.id];

        if (marketUpdate) updateMarket(market, marketUpdate);
      });
    });

    return draft;
  });

export const reducers = {
  clear: (): State => ({ ...defaultState }),
  competitionOutrightsRequested: (
    state: State,
    { isBackgroundLoading = false }: { isBackgroundLoading?: boolean } = {}
  ): State => ({
    ...state,
    isLoading: !isBackgroundLoading
  }),
  sportsCompetitionOutrightsLoadSuccess: (
    _state: State,
    payload: CompetitionOutrightsData
  ): State => ({
    ...payload,
    isLoading: false,
    errorCode: undefined,
    hasPreloaded: true
  }),
  sportsCompetitionOutrightsLoadFailure: (state: State, payload: number): State => ({
    ...state,
    isLoading: false,
    errorCode: payload,
    hasPreloaded: true
  }),
  marketUpdates: (state: State, payload: MarketPollingData): State => updateMarkets(state, payload)
};
